// Normalisiert Adressfelder aus den Einstellungen (Absenderadresse für OTTO-Versandmeldungen).
//
// Beim Kopieren aus Mail, PDF oder Webseite kommen oft Leerzeichen am Rand mit, auch
// geschützte (U+00A0) oder unsichtbare (U+200B, U+FEFF), die `trim()` bzw. Postgres-`trim`
// nicht alle entfernen.

/** Unsichtbare Zeichen ohne Breite, die nur stören. */
const INVISIBLE = /[​-‍⁠﻿]/g;
/** Jede Art von Leerraum, auch geschützte und schmale Leerzeichen. */
const SPACE = /[\s   ]+/g;

/** Länder mit rein numerischer PLZ ohne Leerzeichen darin. */
const NUMERIC_ZIP_COUNTRIES = new Set(['DEU', 'AUT', 'CHE', 'LIE', 'LUX', 'DNK', 'BEL', 'FRA', 'ITA', 'ESP']);

/** Text: Unsichtbares raus, Leerraum zu einem Leerzeichen, Rand weg. */
export function normalizeText(value: string): string {
  return value.replace(INVISIBLE, '').replace(SPACE, ' ').trim();
}

/** PLZ: wie Text, in Großbuchstaben (NL „1234 AB“, GB „SW1A 1AA“); bei rein numerischen Ländern ohne Leerzeichen. */
export function normalizeZip(value: string, countryCode: string): string {
  const zip = normalizeText(value).toUpperCase();
  return NUMERIC_ZIP_COUNTRIES.has(countryCode.trim().toUpperCase()) ? zip.replace(/ /g, '') : zip;
}
